import { useAuth } from '@sp/data/auth';
import { createGlobalState } from 'react-hooks-global-state';

interface ExpertSlugGlobalState {
  expertSlug: string | null;
}

const { useGlobalState } = createGlobalState<ExpertSlugGlobalState>({
  expertSlug: null,
} as const);

export const useExpertSlugGlobalState = () => useGlobalState('expertSlug');

export function useIsUserInsideOwnExpertRoute(): boolean {
  const { user } = useAuth();
  const [expertSlug] = useExpertSlugGlobalState();

  if (user == null || expertSlug == null) {
    return false;
  }

  return user.slug === expertSlug;
}
